import React from 'react'
import styled from 'styled-components'
import { Field as FormikField } from 'formik'

import { media } from '../theme'

const Container = styled.label`
  align-items: center;
  cursor: pointer;
  display: flex;
`

const Radio = styled(FormikField)`
  background-color: ${(p) => p.theme.color.copy};
  border-radius: 50%;
  border: 4px solid ${(p) => p.theme.color.copy};
  cursor: pointer;
  height: 1.5rem;
  margin-right: ${(p) => p.theme.spacing(0)};
  width: 1.5rem;

  &:checked {
    background-color: ${(p) => p.theme.color.Button.bg[1]};
  }
`

const Label = styled.span`
  color: ${(p) => p.theme.color.copySecondary};
  font-family: ${(p) => p.theme.fontFamily.primary};
  font-size: ${(p) => p.theme.fontSize(2)};
  line-height: 1;
  text-transform: uppercase;

  ${media.greaterThan('medium')`
    font-size: ${(p) => p.theme.fontSize(2.5)};
  `};
`

const FormRadio = ({ label, name, value, checked, ...props }) => (
  <Container {...props}>
    <Radio type="radio" value={value} name={name} checked={checked} />
    <Label>{label || name}</Label>
  </Container>
)

export default FormRadio



// WEBPACK FOOTER //
// ./src/components/FormRadio.js